import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var InputLabelTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var _b;
            var theme = _a.theme;
            return (_b = {
                    '&&': {
                        fontSize: theme.typography.body1.fontSize,
                        // transform: `translate(14px, 11px) scale(1)`,
                        transform: "translate(".concat(theme.spacing(1.75), ", ").concat(theme.spacing(1.375), ") scale(1)"),
                    },
                    fontSize: theme.typography.body1.fontSize
                },
                _b[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _b['&.MuiInputLabel-shrink'] = {
                    // transform: `translate(14px, -9px) scale(0.75)`,
                    transform: "translate(".concat(theme.spacing(1.75), ", -").concat(theme.spacing(1.125), ") scale(0.75)"),
                },
                _b['&.MuiInputLabel-sizeSmall'] = {
                    // transform: `translate(8px, 6px) scale(1)`,
                    transform: "translate(".concat(theme.spacing(1), ", ").concat(theme.spacing(0.75), ") scale(1)"),
                    '&.MuiInputLabel-shrink': {
                        transform: "translate(".concat(theme.spacing(1.75), ", -").concat(theme.spacing(1.125), ") scale(0.75)"),
                    },
                },
                _b['&.MuiInputLabel-sizeLarge'] = {
                    // transform: `translate(14px, 16px) scale(1)`,
                    transform: "translate(".concat(theme.spacing(1.75), ", ").concat(theme.spacing(2), ") scale(1)"),
                    '&.MuiInputLabel-shrink': {
                        transform: "translate(".concat(theme.spacing(1.75), ", -").concat(theme.spacing(1.125), ") scale(0.75)"),
                    },
                },
                _b);
        },
        asterisk: {
            color: theme.palette.error.main,
        },
    },
}); };
export default InputLabelTheme;
//# sourceMappingURL=theme.js.map